import * as React from 'react';

import LeadCancelledSvg from '../assets/lead-cancelled.svg';
import LeadLostSvg from '../assets/lead-lost.svg';
import LeadWonSvg from '../assets/lead-won.svg';

import styles from './sales-automation-board-headers.module.css';

export function ClosedLeadOutcomeHeaders() {
    return (
        <div className={styles['headers-container']}>
            <div className={styles['outcome-header']}>
                <div className={styles['outcome-header-body']}>
                    <div className={styles.icon}>
                        <LeadWonSvg />
                    </div>
                    <div className={styles['outcome-header-name']}>Won</div>
                </div>
                <div className={styles.shadow} />
            </div>
            <div className={styles['outcome-header']}>
                <div className={styles['outcome-header-body']}>
                    <div className={styles.icon}>
                        <LeadLostSvg />
                    </div>
                    <div className={styles['outcome-header-name']}>Lost</div>
                </div>
                <div className={styles.shadow} />
            </div>
            <div className={styles['outcome-header']}>
                <div className={styles['outcome-header-body']}>
                    <div className={styles.icon}>
                        <LeadCancelledSvg />
                    </div>
                    <div className={styles['outcome-header-name']}>Cancelled</div>
                </div>
                <div className={styles.shadow} />
            </div>
        </div>
    );
}
